/*
 * @Author: zhaowh zhaowh@example.com
 * @Date: 2023-10-24 21:19:38
 * @LastEditors: zhaowh zhaowh@example.com
 * @LastEditTime: 2023-12-21 17:35:13
 */
import http from "utils/http";
import { base } from "./base";

const jgb = {
    /** 投票活动 */
    // 获取投票奖项分类接口
    getVoteItemList(params) {
        return http.get(`${base.request}/rest/jgb/activity/getVoteItemList`, params);
    },
    // 获取投票对象接口
    getQueryList(params) {
        return http.get(`${base.request}/rest/jgb/activity/queryList`, params);
    },

    /** 终评活动 */
    // 头部视频
    getHeaderVideo(params) {
        return http.get(`${base.request}/jgbZpActive/getHeaderVideo`, params);
    },
    // 评委团队 - 现场终评评委
    getJudges(params) {
        return http.get(`${base.request}/jgbZpActive/getJudges`, params);
    },
    // 评委团队 - 整机企业评委/合作社评委
    getQueryJudgeList(params) {
        return http.get(`${base.request}/rest/jgb/activity/queryJudgeList`, params);
    },
    // 演讲视频
    getSpeechVideos(params) {
        return http.get(`${base.request}/jgbZpActive/getSpeechVideos`, params);
    },
    // 演讲视频详情
    getVideo(params) {
        return http.get(`${base.request}/jgbZpActive/getVideo`, params);
    },
    // 现场图集
    getBottomThumb(params) {
        return http.get(`${base.request}/jgbZpActive/getBottomThumb`, params);
    },

    /* 颁奖现场报道专题 */
    // pc端头部视频
    getHomePageHeaderVideo(params){
        return http.get(`${base.request}/jgb/awardActive/getHomePageHeaderVideo`,params)
    },
    // 资讯列表
    getHomePageNews(params){
        return http.get(`${base.request}/jgb/awardActive/getHomePageNews`,params)
    },
    // 趋势解读
    getPolicyInterpretation(params){
        return http.get(`${base.request}/jgb/awardActive/getPolicyInterpretation`,params)
    },
    // 数字化应用
    getDigitalApplications(params){
        return http.get(`${base.request}/jgb/awardActive/getDigitalApplications`,params)
    },
    // 数字化宣言
    getDeclaration(params){
        return http.get(`${base.request}/jgb/awardActive/getDeclaration`,params)
    },
    // 与会嘉宾
    getAttendees(params){
        return http.get(`${base.request}/jgb/awardActive/getAttendees`,params)
    },
    // 活动报道
    getNews(params){
        return http.get(`${base.request}/jgb/awardActive/getNews`,params)
    },
    // 活动报道详情
    getNewDetail(params){
        return http.get(`${base.request}/jgb/awardActive/getNewsView`,params)
    },
    // 数字大会现场图集
    getMeetingImage(){
        return http.get(`${base.request}/jgb/awardActive/getMeetingImage`)
    },
    // 颁奖盛典特版图片和视频-手机端
    getAwardActiveH5(params){
        return http.get(`${base.request}/jgb/awardActive/getAwardActive`,params)
    },
    // 视频详情
    getVideoView(params){
        return http.get(`${base.request}/jgb/awardActive/getVideoView`,params)
    },
    // 首页现场图集列表
    getHomePageActiveImage(params){
        return http.get(`${base.request}/jgb/awardActive/getHomePageActiveImage`,params)
    },
    // 现场视频列表-手机端
    getMobileVideo(params){
        return http.get(`${base.request}/jgb/awardActive/getMobileVideo`,params)
    },
    // 获取微信分享配置参数
    getShareData(params){
        return http.get(`${base.request}/jgb/weixin/config`,params)
    },
    // 高清图集 - 农机化发展大会
    getMeetingImageList(params){
        return http.get(`${base.request}/jgb/awardActive/getMeetingImageList`,params)
    },
    // 高清图集 - 颁奖盛典
    getAwardImageList(params){
        return http.get(`${base.request}/jgb/awardActive/getAwardImageList`,params)
    },
    // 高清图集 - 欢迎晚宴
    getDinnerImageList(params){
        return http.get(`${base.request}/jgb/awardActive/getDinnerImageList`,params)
    },
    // 视频合集 - 数字发展大会
    getVideoMeeting(params){
        return http.get(`${base.request}/jgb/awardActive/getVideoMeeting`,params)
    },
    // 视频合集 - 颁奖典礼
    getVideoAward(params){
        return http.get(`${base.request}/jgb/awardActive/getVideoAward`,params)
    },
    // 视频合集 - 欢迎晚宴
    getVideoDinner(params){
        return http.get(`${base.request}/jgb/awardActive/getVideoDinner`,params)
    },
    // 媒体支持
    getMedium(params){
        return http.get(`${base.request}/jgb/awardActive/getMedium`,params)
    },
    // 数字发展大会视频
    getMeetingVideoList(params){
        return http.get(`${base.request}/jgb/awardActive/getMeetingVideoList`,params)
    },
    // 颁奖盛典视频列表
    getAwardVideoList(params){
        return http.get(`${base.request}/jgb/awardActive/getAwardVideoList`,params)
    },
    // 颁奖盛典现场图集
    getAwardImage(params){
        return http.get(`${base.request}/jgb/awardActive/getAwardImage`,params)
    },
    // 颁奖盛典现场图集
    getImage(params){
        return http.get(`${base.request}/jgb/awardActive/getImage`,params)
    },
    /* 往届回顾专题 */
    // 往届回顾详情接口
    getReviewView(params){
        return http.get(`${base.request}/projectTheme/view/${params}`)
    },
    // 企业访谈
    getQueryNews(params){
        return http.get(`${base.request}/projectTheme/queryNews/${params}`)
    },
    // 颁奖典礼
    getQueryVideos(params){
        return http.get(`${base.request}/projectTheme/queryVideos/${params}`)
    },
    // 高清图集
    getQueryImages(params){
        return http.get(`${base.request}/projectTheme/queryImages/${params}`)
    },
    // 获奖榜单一级
    getItemList(params){
        return http.get(`${base.request}/projectTheme/getItemList`,params)
    },
    // 往届回顾
    getQueryProjectList(params){
        return http.get(`${base.request}/projectTheme/queryProjectList/${params}`)
    },
}

export default {
    ...jgb,
};